import { api } from './api';
import { IDraft } from '../../interfaces/IDraft';
import { IObject } from '../../interfaces/IObject';

export const draftApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDraft: build.query<IDraft, string>({
      query: (id) => `draft/${id}/`,
      providesTags: (_result, _err, id) => {
        return [{ type: 'Draft' as const, id }];
      },
    }),
    getDocument: build.query({
      query: (body: IObject) => ({
        url: 'azure/presigned-url/',
        method: 'POST',
        body,
      }),
    }),
    getErrorProne: build.query<{ success: boolean }, void>({
      query: () => 'error-prone',
    }),
  }),
});

export const { useGetDraftQuery, useGetErrorProneQuery, useGetDocumentQuery } =
  draftApi;

export const {
  endpoints: { getDraft, getDocument },
} = draftApi;
